import i from "./highrise1576.mjs";
import c from "./highrise1580.mjs";
import m from "./highrise1578.mjs";
import f from "./highrise1408.mjs";
function d(t) {
  return function(r) {
    r = f(r);
    var o = c(r) ? m(r) : void 0, a = o ? o[0] : r.charAt(0), e = o ? i(o, 1).join("") : r.slice(1);
    return a[t]() + e;
  };
}
export {
  d as default
};
